import { createAction, props } from '@ngrx/store'

export const source = '[Sort by component]'

export const sort = createAction(`${source} Sort`, props<{key: string; sortValue: string}>())